/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import SurveyInserterConfiguration from 'embercom/objects/series/node/survey-inserter-configuration';

export default class SurveyNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new SurveyInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
